import { Button, CircularProgress } from "@mui/material";
import { styled } from "@mui/material/styles";
import { ColorPallet } from "../../utils/colorPallet";

const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: ColorPallet?.primaryBlue,
  borderRadius: "4px",
  border: "none",
  textTransform: "capitalize",
  fontSize: "16px",
  color: ColorPallet?.neutralWhite,

  ":hover": {
    border: "none",
    backgroundColor: "darkBlue",
  },
  ":disabled": {
    backgroundColor: `rgba(${ColorPallet?.primaryBlue}, 0.2)`,
    pointer: "none",
    color: "white",
  }
}));

function AppButton({ title, onClick, type = "button", isLoading, ...rest }: any) {
  return (
    <StyledButton onClick={onClick} type={type} disabled={isLoading} {...rest}>
      {isLoading ? <CircularProgress size={25} style={{ color: ColorPallet.neutralWhite }} /> : title}
    </StyledButton>
  );
}

export default AppButton;

const StyledButton2 = styled(Button)(({ theme }) => ({
  borderRadius: "4px",
  border: "1px solid",
  borderColor: "#C3C3C3",
  color: "#131318",
  textTransform: "none",
  fontWeight: "normal",
}));

export const AppButton2 = ({ title, onClick, ...rest }: any) => {
  return (
    <StyledButton2 onClick={onClick} type="submit" {...rest}>
      {title}
    </StyledButton2>
  );
};
export const AppButton3 = () => {
  return (
    <StyledButton>
      <CircularProgress size={25} style={{ color: ColorPallet.neutralWhite }} />
    </StyledButton>
  );
};
